"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _constants = require("../utils/constants");

var _default = {
  title: 'Text Box Border Radius',
  description: "Set the border radius of the texts container for each item.",
  isRelevant: function isRelevant(styleParams) {
    return styleParams.titlePlacement !== _constants.GALLERY_CONSTS.placements.SHOW_ON_HOVER && (styleParams.allowTitle || styleParams.allowDescription) && styleParams.imageInfoType === _constants.GALLERY_CONSTS.infoType.SEPARATED_BACKGROUND;
  },
  type: _constants.INPUT_TYPES.NUMBER,
  "default": 0
};
exports["default"] = _default;